import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import JisDialogForm from "../../components/formdialog";
import PdfViewer from "../../components/controls/pdfviewer";


function VerifyWebguid() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
const [pay, setPay] = useState(null);

      const [previewUrl, setPreviewUrl] = useState("");

   useEffect(() => {
   
    if (search != null) {
        onSearch(search);
    }
  }, [search]);

  const onSearch = async (sear) => {
    console.log(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/payment/get-revenue-receipt/${encodeURIComponent(sear.caseTitle)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if  (data.code == 0 ) {
        setPay(data.payreceipt);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };


  const onContinue = (caseid) => {
    navigate(`/case-details/${caseid}`);
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
 const onRevenueReceipt = () => {
    setPreviewUrl(pay?.receipt);
    setIsPreview(true);
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
        isSearchOnly={true}
      />
     <div>
        <div class="receipt-section">
                          <div class="icons">
                            <DynamicIcon iname="done" size={60} />
                          </div>
              
                          <h3>Payment {pay?.status}</h3>
                          <div className="payment-details">
                            <div className="row">
                              <strong>Payer ID:</strong>
                              <span>{pay?.payerId}</span>
                            </div>
                            <div className="row">
                              <strong>Payer Name:</strong>
                              <span>{pay?.payerName}</span>
                            </div>
                            <div className="row">
                              <strong>Transaction Number:</strong>
                              <span>{pay?.paymentTrans}</span>
                            </div>
                            <div className="row">
                              <strong>Date and Time of Transaction:</strong>
                              <span>{Constants.displayDateTime(pay?.paymentDate)}</span>
                            </div>
                            <div className="row">
                              <strong>Receiving HOA Name:</strong>
                              <span>{pay?.agencyName}</span>
                            </div>
                            <div className="row">
                              <strong>Payment Details:</strong>
                              <span>Success</span>
                            </div>
              
                            <div className="row">
                              <strong>Bill Reference Number:</strong>
                              <span>{pay?.reference}</span>
                            </div>
                            {/*  <div className="row"><strong>Address:</strong><span>20B, Adeola Estate, Ogba, Lagos</span></div> */}
                            <div className="row">
                              <strong>Amount:</strong>
                              <span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span>
                            </div>
                            <div className="row">
                              <strong>Agency:</strong>
                              <span>{pay?.agencyCode}</span>
                            </div>
                            <div className="row">
                              <strong>Revenue Code:</strong>
                              <span>{pay?.revenueCode}</span>
                            </div>
                          </div>
                          <div class="receipt-buttons">
                           
                            <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>
                            
                          </div>
                        </div>
     </div>
      <BackLoader open={loading} />
       {isPreview && (
                     <JisDialogForm title="Preview" onClose={() => setIsPreview(false)}>
                       <div>
                         <div style={{ height: "90vh" }}>
                           <PdfViewer pdfUrl={previewUrl} />
                         </div>
                       </div>
                     </JisDialogForm>
                   )}     
    </div>
  );
}

export default VerifyWebguid;
